define ('localizationService',[
	"jquery",
	"jquery-cookie",
	"l10n"
],

function($) {
	/* handles our localization service */
	var LocalizationService = {};
    
    // returns the current localization language
	LocalizationService.getLanguage = function() {
        return $.cookie("lang") || document.getElementsByTagName("html")[0].lang;
    };

    // sets a localization language
	LocalizationService.setLanguage = function(newLang) {
        $.cookie("lang", newLang, { path : '/' });

        document.getElementsByTagName("html")[0].lang = newLang;
        
        // setting String.locale here is needed for l10n.js to get the current language
        String.locale = newLang;
        return newLang;
    };
    
	// redefine l10n's localize function for easy global access as function "l"
	LocalizationService.localize = function (string, fallback) {
		var localized = string.toLocaleString();
		if (localized !== string) {
			return localized;
		// if fallback wasn't specified, reutrn the string so that 'undefined' isn't returned
		} else if (fallback) {
			return fallback;
		} else {
			return string;
		}
	};

	//expands the localization service method to allow for variables to be used in place of phrases
	LocalizationService.sLocalize = function (string, replacements, fallback) {
		var localized = LocalizationService.localize(string, fallback);
		//find the variable in the localization string that matches the parameter and insert the value passed in
		if (localized !== string) {
			if (replacements && !Array.isArray(replacements) && typeof replacements === 'object') {
				localized = localized.replace(/\$\{\w+\}/g, function(match) {
					var keyToMatch = match.replace(/[${}]/g, '');
				
					return keyToMatch in replacements ? replacements[keyToMatch] : match;
				});
			}
		return localized;
		} 
	}

	LocalizationService.setLanguage(window.ResolvedLang);
	
	return LocalizationService; 
});
